import { Button } from "@progress/kendo-react-buttons";
import { ArrowLeftIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ErrorBoundary = () => {
  const navigate = useNavigate();

  return (
    <section className="min-h-screen flex flex-col items-center justify-center">
      <div className="p-4 grid grid-cols-2 gap-4 items-center">
        <div>
          <img src="/images/image404.png" alt="" className="max-w-full" />
        </div>
        <div className="text-center">
          <h2 className="font-kanit leading-[1] font-medium text-[68px] tracking-[-0.4px]  text-[#03274E]">
            500
          </h2>
          <h4 className="my-3 leading-normal font-kanit font-medium text-[40px] tracking-[-0.4px] text-[#03274E]">
            Unexpected Error!
          </h4>
          <p className="mb-4 font-kanit font-light text-[18px] tracking-[-0.4px] text-primary max-w-[468px] mx-auto">
            We’re sorry there is some unexpected error. Can you please try again and if the issue persists, please contact the support team.
          </p>
          <Button themeColor={"primary"} onClick={() => navigate(-1)}>
            {" "}
            <span className="flex items-center gap-2">
              <i>
                <ArrowLeftIcon />
              </i>{" "}
              Go Back
            </span>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ErrorBoundary;
